export default __webpack_public_path__ + "static/media/doc1.bec2f051.png";